"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteRenderer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var content_1 = require("./dialogs/content");
var message_1 = require("./dialogs/message");
var section_renderer_1 = require("./section-renderer");
var footer_1 = require("./sections/footer");
var hero_carousel_1 = require("./sections/hero-carousel");
var navigation_1 = require("./sections/navigation");
var topbar_1 = require("./sections/topbar");
var SiteRenderer = function (_a) {
    var _b, _c;
    var config = _a.config;
    // Set document title based on site config
    (0, react_1.useEffect)(function () {
        if (config.name) {
            document.title = config.name;
        }
    }, [config.name]);
    var safeSections = Array.isArray(config.sections) ? config.sections : [];
    var safeNavigation = __assign(__assign({}, config.navigation), { items: Array.isArray((_b = config.navigation) === null || _b === void 0 ? void 0 : _b.items)
            ? config.navigation.items
            : [] });
    var safeHeroSlides = Array.isArray(config.heroSlides)
        ? config.heroSlides
        : [];
    var safeFooter = __assign(__assign({}, config.footer), { links: Array.isArray((_c = config.footer) === null || _c === void 0 ? void 0 : _c.links) ? config.footer.links : [] });
    return ((0, jsx_runtime_1.jsxs)("div", { className: "min-h-screen", children: [(0, jsx_runtime_1.jsx)(topbar_1.Topbar, { contact: config.contact, branding: config.branding, siteConfig: config }), (0, jsx_runtime_1.jsx)(navigation_1.Navigation, { navigation: safeNavigation, branding: config.branding, siteName: config.name, authentication: config.authentication, sections: safeSections, siteConfig: config }), (0, jsx_runtime_1.jsx)(hero_carousel_1.HeroCarousel, { slides: safeHeroSlides, branding: config.branding, socialMedia: config.socialMedia }), (0, jsx_runtime_1.jsx)("main", { children: safeSections
                    .filter(function (section) { return !section.hidden; })
                    .map(function (section, index) { return ((0, jsx_runtime_1.jsx)(section_renderer_1.SectionRenderer, { section: section, branding: config.branding, contact: config.contact, siteConfig: config }, "".concat(section.id, "-").concat(index))); }) }), (0, jsx_runtime_1.jsx)(footer_1.Footer, { footer: safeFooter, contact: config.contact, branding: config.branding, navigation: safeNavigation, socialMedia: config.socialMedia, sections: safeSections }), (0, jsx_runtime_1.jsx)(content_1.ContentDialog, {}), (0, jsx_runtime_1.jsx)(message_1.ModalMessage, {})] }));
};
exports.SiteRenderer = SiteRenderer;
